<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Select v-model="region" style="width:120px">
          <Option value="CN">全国标准</Option>
          <Option value="GD">广东地区</Option>
        </Select>
      </Cell>
      <Cell>
        <DatePicker v-model="year" type="year" format="yyyy" style="width:110px" placeholder="年度"></DatePicker>
      </Cell>
      <Cell>
        <Select v-model="month" style="width:90px" placeholder="月份">
          <Option v-for="m in 12" :value="m" :key="m">{{ m }}月</Option>
        </Select>
      </Cell>
      <Cell>
        <Button color="primary" @click="doPreview" :loading="loading">申报预览</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="doSubmit" :loading="submitting" :disabled="!rows.length">提交申报</Button>
      </Cell>
      <Cell>
        <Button @click="openWage">缴费工资查询</Button>
      </Cell>
    </Row>

    <Alert class="margin-right-left margin-top" type="info">
      单位应缴费率：养老 {{ rates.pension * 100 }}%、医疗 {{ rates.medical * 100 }}%、失业 {{ rates.unemployment * 100 }}%、
      工伤 {{ rates.injury * 100 }}%、生育 {{ rates.maternity * 100 }}%、住房公积金 {{ rates.housingFund * 100 }}%（以当地政策为准，可提交税务前核对）。
    </Alert>

    <!--预览表-->
    <div class="h-panel-body padding-top">
      <Table :datas="rows" :border="true" :loading="loading">
        <TableItem title="姓名" prop="name" :width="100"></TableItem>
        <TableItem title="证件号码" prop="certNo" :width="170"></TableItem>
        <TableItem title="缴费工资" align="right">
          <template slot-scope="{data}">{{ money(data.declareWage) }}</template>
        </TableItem>
        <TableItem title="养老保险" align="right">
          <template slot-scope="{data}">{{ money(data.pension) }}</template>
        </TableItem>
        <TableItem title="医疗保险" align="right">
          <template slot-scope="{data}">{{ money(data.medical) }}</template>
        </TableItem>
        <TableItem title="失业保险" align="right">
          <template slot-scope="{data}">{{ money(data.unemployment) }}</template>
        </TableItem>
        <TableItem title="工伤保险" align="right">
          <template slot-scope="{data}">{{ money(data.injury) }}</template>
        </TableItem>
        <TableItem title="生育保险" align="right">
          <template slot-scope="{data}">{{ money(data.maternity) }}</template>
        </TableItem>
        <TableItem title="住房公积金" align="right">
          <template slot-scope="{data}">{{ money(data.housingFund) }}</template>
        </TableItem>
        <TableItem title="单位应缴合计" align="right">
          <template slot-scope="{data}"><b>{{ money(data.totalAmount) }}</b></template>
        </TableItem>
      </Table>
    </div>

    <!--缴费工资查询弹窗-->
    <Modal v-model="wageModal" title="缴费工资查询" width="700">
      <Table :datas="wageRows" :border="true" :loading="wageLoading">
        <TableItem title="姓名" prop="name"></TableItem>
        <TableItem title="证件号码" prop="certNo"></TableItem>
        <TableItem title="缴费工资" align="right">
          <template slot-scope="{data}">{{ money(data.declareWage) }}</template>
        </TableItem>
        <TableItem title="状态" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.declareStatus === 1 ? 'success' : 'warning'">
              {{ data.declareStatus === 1 ? '已申报' : '未申报' }}
            </Tag>
          </template>
        </TableItem>
      </Table>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'SocialDeclare',
  data() {
    let now = new Date();
    return {
      region: 'CN',
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      loading: false,
      submitting: false,
      rows: [],
      rates: {pension: 0.16, medical: 0.08, unemployment: 0.005, injury: 0.002, maternity: 0.008, housingFund: 0.05},
      wageModal: false,
      wageRows: [],
      wageLoading: false
    };
  },
  methods: {
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    doPreview() {
      if (!this.year || !this.month) {
        this.$Message.warning('请选择费款所属年月');
        return;
      }
      this.loading = true;
      this.$api.pro.social.preview({
        region: this.region, year: this.year, month: this.month
      }).then(({data}) => {
        this.rows = data.results || [];
      }).finally(() => this.loading = false);
    },
    doSubmit() {
      if (!this.rows.length) {
        this.$Message.warning('请先进行申报预览');
        return;
      }
      this.$Confirm(`确认提交 ${this.year}年${this.month}月社保费申报？共 ${this.rows.length} 人。`).then(() => {
        this.submitting = true;
        this.$api.pro.social.submit({
          region: this.region, year: this.year, month: this.month, rates: this.rates
        }).then(() => {
          this.$Message.success('社保费申报提交成功');
          this.doPreview();
        }).finally(() => this.submitting = false);
      });
    },
    openWage() {
      this.wageModal = true;
      this.wageLoading = true;
      this.$api.pro.social.wage({year: this.year, page: 1, pageSize: 50}).then(({data}) => {
        this.wageRows = data.results || [];
      }).finally(() => this.wageLoading = false);
    }
  }
}
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 10px;
}
</style>
